/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from "@cian/http-api/shared/model";
import { IConcurrencyTypeModel } from "../../entities/Models/ConcurrencyTypeModel";

export type TGetIncreaseBetsPositionsCountByAnnouncementModel = IModel<
  IGetIncreaseBetsPositionsCountByAnnouncementRequest,
  TGetIncreaseBetsPositionsCountByAnnouncementResponse
>;

export interface IGetIncreaseBetsPositionsCountByAnnouncementRequest {
  /** Ставка **/
  bet?: number | null;
  /** Id объявления **/
  announcementId?: number | null;
  /** Категория объявления **/
  category?: ECategory | null;
  /** Id локации **/
  geoId?: number | null;
  /** Тип локации **/
  geoType?: EGeoType | null;
  /** Уровень конкуренции **/
  concurrencyType?: EConcurrencyType | null;
  /** Цена **/
  price?: number | null;
  /** Услуга **/
  service?: EService | null;
}

export type TGetIncreaseBetsPositionsCountByAnnouncementResponse =
  | IGetIncreaseBetsPositionsCountByAnnouncementResponse200
  | IGetIncreaseBetsPositionsCountByAnnouncementResponse400;

export interface IGetIncreaseBetsPositionsCountByAnnouncementResponse200
  extends IModelResponse<IGetIncreaseBetsPositionsCountByAnnouncementResponse> {
  statusCode: 200;
}

export interface IGetIncreaseBetsPositionsCountByAnnouncementResponse400
  extends IModelResponse<
    IGetIncreaseBetsPositionsCountByAnnouncementResponseError
  > {
  statusCode: 400;
}

export interface IGetIncreaseBetsPositionsCountByAnnouncementResponse {
  /** Количество пользователей, которые будут выше твоей ставки. **/
  increaseBetsPositionsCount: number;
  /** Доступные уровни конкуренции **/
  concurrencyTypes: IConcurrencyTypeModel[];
  /** Лидирующая ставка **/
  topBet?: number | null;
  /** Страница в выдаче **/
  currentSerpPage: number;
  /** Позиция в выдаче **/
  serpPosition: number;
  /** Количество объявлений, которые будут выше текущего при сквозной конкуренции **/
  betFullConcurrency?: number | null;
  /** Количество объявлений, которые будут выше текущего в рамках услуги **/
  betServiceConcurrency?: number | null;
  /** Позиция в выдаче по сквозной конкуренции по ставке **/
  betPositionFullConcurrency?: number | null;
  /** Страница в сквозной конкуренции **/
  betPageFullConcurrency?: number | null;
}

export interface IGetIncreaseBetsPositionsCountByAnnouncementResponseError {
  errors: any[];
  message: string;
}

export type TResponses =
  | IGetIncreaseBetsPositionsCountByAnnouncementResponse
  | IGetIncreaseBetsPositionsCountByAnnouncementResponseError;

export enum ECategory {
  /** Койко-место = 0 **/
  BedRent = "bedRent",
  /** Здание = 1 **/
  BuildingRent = "buildingRent",
  /** Здание = 2 **/
  BuildingSale = "buildingSale",
  /** Готовый бизнес = 3 **/
  BusinessRent = "businessRent",
  /** Готовый бизнес = 4 **/
  BusinessSale = "businessSale",
  /** Аренда автосервис = 5 **/
  CarServiceRent = "carServiceRent",
  /** Продажа автосервиса = 6 **/
  CarServiceSale = "carServiceSale",
  /** Коммерческая земля = 7 **/
  CommercialLandRent = "commercialLandRent",
  /** Коммерческая земля = 8 **/
  CommercialLandSale = "commercialLandSale",
  /** Коттедж = 9 **/
  CottageRent = "cottageRent",
  /** Коттедж = 10 **/
  CottageSale = "cottageSale",
  /** Посуточная аренда койко-места = 11 **/
  DailyBedRent = "dailyBedRent",
  /** Посуточная аренда квартиры = 12 **/
  DailyFlatRent = "dailyFlatRent",
  /** Посуточная аренда дома, дачи, коттеджа = 13 **/
  DailyHouseRent = "dailyHouseRent",
  /** Посуточная аренда комнаты = 14 **/
  DailyRoomRent = "dailyRoomRent",
  /** Аренда помещения под бытовые услуги = 15 **/
  DomesticServicesRent = "domesticServicesRent",
  /** Продажа помещения под бытовые услуги = 16 **/
  DomesticServicesSale = "domesticServicesSale",
  /** Квартира = 17 **/
  FlatRent = "flatRent",
  /** Квартира = 18 **/
  FlatSale = "flatSale",
  /** Доля в квартире = 19 **/
  FlatShareSale = "flatShareSale",
  /** Помещение свободного назначения = 20 **/
  FreeAppointmentObjectRent = "freeAppointmentObjectRent",
  /** Помещение свободного назначения = 21 **/
  FreeAppointmentObjectSale = "freeAppointmentObjectSale",
  /** Гараж = 22 **/
  GarageRent = "garageRent",
  /** Гараж = 23 **/
  GarageSale = "garageSale",
  /** Дом/дача = 24 **/
  HouseRent = "houseRent",
  /** Дом/дача = 25 **/
  HouseSale = "houseSale",
  /** Часть дома = 26 **/
  HouseShareRent = "houseShareRent",
  /** Часть дома = 27 **/
  HouseShareSale = "houseShareSale",
  /** Производство = 28 **/
  IndustryRent = "industryRent",
  /** Производство = 29 **/
  IndustrySale = "industrySale",
  /** Участок = 30 **/
  LandSale = "landSale",
  /** Квартира в новостройке = 31 **/
  NewBuildingFlatSale = "newBuildingFlatSale",
  /** Офис = 32 **/
  OfficeRent = "officeRent",
  /** Офис = 33 **/
  OfficeSale = "officeSale",
  /** Аренда общепита = 34 **/
  PublicCateringRent = "publicCateringRent",
  /** Продажа общепита = 35 **/
  PublicCateringSale = "publicCateringSale",
  /** Комната = 36 **/
  RoomRent = "roomRent",
  /** Комната = 37 **/
  RoomSale = "roomSale",
  /** Торговая площадь = 38 **/
  ShoppingAreaRent = "shoppingAreaRent",
  /** Торговая площадь = 39 **/
  ShoppingAreaSale = "shoppingAreaSale",
  /** Таунхаус = 40 **/
  TownhouseRent = "townhouseRent",
  /** Таунхаус = 41 **/
  TownhouseSale = "townhouseSale",
  /** Склад = 42 **/
  WarehouseRent = "warehouseRent",
  /** Склад = 43 **/
  WarehouseSale = "warehouseSale"
}

export enum EGeoType {
  /** Страна **/
  Country = "country",
  /** Локация **/
  Location = "location",
  /** Улица **/
  Street = "street",
  /** Шоссе **/
  Road = "road",
  /** Район **/
  District = "district",
  /** Метро **/
  Underground = "underground",
  /** Дом **/
  House = "house"
}

export enum EConcurrencyType {
  /** Конкуренция в регионе **/
  Region = "region",
  /** Локальная конкуренция **/
  Local = "local",
  /** Конкуренция по соседству **/
  NearBy = "nearBy"
}

export enum EService {
  /** Бесплатное **/
  Free = "free",
  /** <a href="http://www.cian.ru/promo/adv/#color" target="_blank">Выделение цветом</a> **/
  Highlight = "highlight",
  /** Платное **/
  Paid = "paid",
  /** <a href="http://www.cian.ru/promo/adv/#premium" target="_blank">Премиум-объявление</a> **/
  Premium = "premium",
  /** <a href="http://www.cian.ru/promo/adv/#top3" target="_blank">Топ 3</a> **/
  Top3 = "top3",
  /** Подмена номера, Calltracking, оно же "защита номера" **/
  Calltracking = "calltracking",
  /** Аукцион **/
  Auction = "auction"
}

export interface IMappers<TResponse200, TResponse400> {
  200(
    response: IGetIncreaseBetsPositionsCountByAnnouncementResponse
  ): TResponse200;
  400(
    response: IGetIncreaseBetsPositionsCountByAnnouncementResponseError
  ): TResponse400;
}
